<template>
    <div>
        <pulse-loader :loading="loading"></pulse-loader>

        <div
            v-if="!loading"
            v-for="category in categorizedOptions"
            :key="category.id"
        >
            <h5 class="mb-3 mt-4">{{ category.name }}</h5>
            <div v-for="option in category.options" :key="option.id">
                <label
                    class="label-box"
                    :class="{ selected: isSelected(option) }"
                >
                    <div class="input">
                        <input
                            type="checkbox"
                            :value="option"
                            v-model="currentOptions"
                        />
                        <i
                            class="active-icon fa fa-check-square-o"
                            aria-hidden="true"
                        ></i>
                        <i
                            class="inactive-icon fa fa-square-o"
                            aria-hidden="true"
                        ></i>
                    </div>

                    <div class="text">
                        {{ option.name }}
                    </div>

                    <div class="price">
                        <price-diff :value="option.price"></price-diff>
                    </div>
                </label>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
h4 {
    font-weight: bold;
}
</style>

<script>
import CatalogModelOptionMixin from "../mixins/CatalogModelOption";

export default {
    mixins: [CatalogModelOptionMixin],

    props: {
        model: {
            type: Object,
            required: true,
        },
    },

    created: function () {
        this.getCatalogModelOptionsCategorized(this.model, {
            locale: this.locale,
        }).then((response) => {
            this.categorizedOptions = response.data;
            this.$_sortCategories();
            this.$_sortOptions();
            this.loading = false;
        });
    },

    inject: ["locale"],

    data: function () {
        return {
            categorizedOptions: null,
            currentOptions: [],
            loading: true,
        };
    },

    watch: {
        currentOptions: function (value) {
            this.$emit("select", value);
        },
    },

    methods: {
        isSelected(option) {
            return this.currentOptions.indexOf(option) !== -1;
        },

        $_sortCategories() {
            this.categorizedOptions.sort((a, b) => {
                let _a = a.name;
                let _b = b.name;

                if (_a < _b) {
                    return -1;
                } else if (_a == _b) {
                    return 0;
                } else {
                    return 1;
                }
            });
        },

        $_sortOptions() {
            for (let category of this.categorizedOptions) {
                category.options.sort((a, b) => {
                    let _a = a.name;
                    let _b = b.name;

                    if (_a < _b) {
                        return -1;
                    } else if (_a == _b) {
                        return 0;
                    } else {
                        return 1;
                    }
                });
            }
        },
    },
};
</script>
